export var BUTTON_LEVEL = /* @__PURE__ */ ((BUTTON_LEVEL2) => {
  BUTTON_LEVEL2["PRIMARY"] = "primary";
  BUTTON_LEVEL2["SECONDARY"] = "secondary";
  return BUTTON_LEVEL2;
})(BUTTON_LEVEL || {});
export var BUTTON_SIZE = /* @__PURE__ */ ((BUTTON_SIZE2) => {
  BUTTON_SIZE2["DEFAULT"] = "default";
  BUTTON_SIZE2["SMALL"] = "small";
  BUTTON_SIZE2["MEDIUM"] = "medium";
  BUTTON_SIZE2["LARGE"] = "large";
  return BUTTON_SIZE2;
})(BUTTON_SIZE || {});
